<h1 mat-dialog-title>Alterar forma de pagamento</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: '700';">
  <form [formGroup]="formaPagamentoForm">
    <div class="borda">
      <div class="row">
        <div class="col-auto">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Forma de pagamento</mat-label>
            <mat-select formControlName="formaPagamento">
              <mat-option *ngFor="let tipo of aFormaPagamento" [value]="tipo.value">
                {{tipo.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-auto" *ngIf="f.formaPagamento.value === 'Boleto'">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Nº de parcelas</mat-label>
            <mat-select formControlName="numeroParcelas">
              <mat-option *ngFor="let numero of aNumeroParcelas" [value]="numero.value">
                {{numero.name}}
              </mat-option>
            </mat-select>
            <mat-hint align="end" *ngIf="f.numeroParcelas.value === 2">Controle manual para os prazos</mat-hint>
          </mat-form-field>
        </div>

        <div class="col-auto" *ngIf="f.formaPagamento.value === 'Boleto' && f.numeroParcelas.value === 1">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Prazo</mat-label>
            <mat-select formControlName="prazoBoleto">
              <mat-option *ngFor="let prazo of aPrazoBoletos" [value]="prazo.value">
                {{prazo.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-auto" *ngIf="f.formaPagamento.value === 'Nota'">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Prazo da nota</mat-label>
            <mat-select formControlName="prazoNota">
              <mat-option *ngFor="let prazo of aPrazoNota" [value]="prazo.value">
                {{prazo.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-auto"
          *ngIf="f.formaPagamento.value === 'Cartão de crédito' || f.formaPagamento.value === 'Cartão de débito'">
          <mat-form-field appearance="fill" [floatLabel]="'always'">
            <mat-label>Bandeira cartão</mat-label>
            <mat-select formControlName="bandeiraCartao">
              <mat-option *ngFor="let bandeira of aBandeirasCartao" [value]="bandeira.value">
                {{bandeira.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="sStringMinimoBoleto">
        <div class="col-sm ml-2">
          <small>{{sStringMinimoBoleto}}</small>
        </div>
      </div>
    </div>
  </form>

  <mat-divider></mat-divider>

  <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
    <button mat-flat-button color="warn" (click)="cancelar()">
      <mat-icon>clear</mat-icon> Cancelar
    </button>
    <button mat-flat-button color="primary" (click)="confirmarAlteracaoFormaPagamento()">
      <mat-icon>check</mat-icon> Confirmar alteração
    </button>
  </section>
</div>
